var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3881 14.3776L26.1546 5.33301H24.2867L17.5033 13.1978L12.0962 5.33301H6.00098L14.1607 17.2286L6.00098 26.6663H7.86887L14.9472 18.4083L20.6492 26.6663H26.8428L18.3881 14.3776ZM15.9303 17.3269L15.1438 16.1471L8.45873 6.70935H11.3097L16.6185 14.2792L17.405 15.459L24.2867 25.29H21.4357L15.9303 17.3269Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.93ec2414ed1c74e155bda6ac0d7aad1c.svg";
export { ForwardRef as ReactComponent };